import React from 'react';

export const useInitialEffect = (cb: () => void) => {
  // biome-ignore lint/correctness/useExhaustiveDependencies(cb): [chris hunter] - cb only called once
  React.useEffect(() => {
    cb();
  }, []);
};
